<template>
    <div class="large-panel" @click.stop>
        <div class="dialog-title" v-t="'message.title_bell_select_target_group'"/>
        <hr class="dialog-hr">
        <div class="dialog-body">
            <table width=100% height=100% cellpadding=0 cellspacing=0>
                <tr class="dialoginputfield">
                    <td colspan=2>
                        <div style="padding: 10px;">
                            <el-form @submit.native.prevent="findGroup()">
                                <el-radio-group style="padding-left:10px" v-model="listType" fill="#5171cb">
                                    <el-radio-button :label="0"><span v-t="'message.action_select_by_list'"/></el-radio-button>
                                    <el-radio-button :label="1"><span v-t="'message.action_select_by_search'"/></el-radio-button>
                                </el-radio-group>
                                <el-input v-if="listType === 1" :placeholder="$t('message.place_holder_input_text')" v-model.trim="searchString" clearable class="object-search-select">
                                    <el-select v-model="condition" slot="prepend" :placeholder="$t('message.place_holder_search_condition')" class="search-item">
                                        <el-option :label="$t('message.item_groupId')" value="groupId"></el-option>
                                        <el-option :label="$t('message.item_groupDisplayName')" value="groupName"></el-option>
                                    </el-select>
                                    <el-button slot="append" style="width: 100px;vertical-align:middle" native-type="submit" v-t="'message.action_search_items'"></el-button>
                                </el-input>
                            </el-form>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="dialog-td">
                        <div class="inner-panel-header">
                            <div class="inner-panel-title">
                                <div class="inner-panel-title-left" v-t="'message.title_select_group'">
                                </div>
                                <div v-if="listType === 1" class="inner-panel-title-right">
                                    <!--<button class="transparent" disabled @click="selectTagAll()" type="button"><span class="normal-command-text" v-t="'message.action_select_all'"></span></button>-->
                                </div>
                            </div>
                        </div>
                        <div v-if="listType === 0" class="inner-panel-dialog" style="height: calc(80vh - 250px);">
                            <DialogTree
                                class="dialog-tree"
                                v-bind:initialData="[rootNode]"
                                @on-selectnode="handleOnSelectNode"
                                selectionType=2
                                ref="dialogTree">
                            </DialogTree>
                        </div>
                        <div v-else class="inner-panel-dialog" style="height: calc(80vh - 250px);">
                            <div class="foundObject-record" v-for="object in foundGroupList" @click="changeTag(object.node.data)">
                                <div class="foundObject">
                                    <span style="padding-left:10px;vertical-align:middle">{{ object.node.data.label }}</span>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td class="dialog-td">
                        <div class="inner-panel-header">
                            <div class="inner-panel-title">
                                <div class="inner-panel-title-left" v-t="'message.title_editing_group'">
                                </div>
                                <div class="inner-panel-title-right">
                                    <!--<button class="transparent" disabled @click="removeAllUserTag()" type="button"><span class="normal-command-text" v-t="'message.action_delete_all'"></span></button>-->
                                </div>
                            </div>
                        </div>
                        <div class="inner-panel-dialog" style="height: calc(80vh - 250px);">
                            <div class="selected-item-field">
                                <div class="default-message" v-if="!Object.keys(tagList).length" v-html="$t('message.hint_add_group_to_user')"/>
                                <div v-else>
                                    <span v-for="tag in tagList" v-bind:key="tag.id">
                                        <div class="userTag">
                                            <span class="userTag-name">{{ tag.displayName }}</span>
                                            <span>&nbsp;</span>
                                            <!--<span class="closeTag" @click="removeTag(tag)">×</span>-->
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <hr class="dialog-hr">
        <div class="dialog-button-field">
            <el-button class="dialog-cancel-button" type="button" @click="$emit('none')" v-t="'message.button_cancel'"></el-button>
            <el-button class="dialog-ok-button" @click="$emit('ok', tagList)" v-t="'message.button_ok'"></el-button>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import DialogTree from "./DialogTree.vue"
import commonUtil from './commonutil.js';
import constants from './constants.js';

export default {
    components: {
        DialogTree
    },

    props: {
        editingGroups: {
            type: Array,
            required: true
        },
        tenantId: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            rootNode: {
                tenantId: this.tenantId,
                id: 1,
                label: "ROOT-NODE",
                type: 0,
                isLeaf: false
            },
            tagList: {},
            foundGroupList: [],
            listType: 0,
            condition: "groupId",
            searchString: null,
            disableSave: true,
        };
    },

    created() {
        this.disableSave = true;
        this.initCurrentGroups();
    },

    methods: {
        initCurrentGroups() {
            for (let group of this.editingGroups) {
                let tagInfo = {
                    id: this.tenantId + "-" + group.talkgroupId,
                    tenantId: this.tenantId,
                    type: constants.OBJECT_TALKGROUP,
                    talkgroupId: group.talkgroupId,
                    talkgroupName: group.talkgroupName,
                    displayName: group.displayName,
                    label: group.talkgroupName,
                };
                Vue.set(this.tagList, tagInfo.id, tagInfo);
            }
        },
        async findGroup() {
            let param = {tenantId: this.tenantId}
            if (this.condition === "groupId") {
                param.name = this.searchString;
            } else if (this.condition === "groupName") {
                param.displayName = this.searchString;
            }

            try {
                const res = await server.post("/findgroup", param)
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        if (res.data.groupInfo.length === 0) {
                            this.foundGroupList = [];
                            commonUtil.notifyMessage(this, "Info", commonUtil.getMessageText(this.$i18n, "info_group_not_found").replace('{object}', commonUtil.getMessageText(this.$i18n, "item_group")));
                            break;
                        }
                        this.foundGroupList = [];
                        for (let objectInfo of res.data.groupInfo) {
                            let object = {node: {data: null, parent: {data: null}}}
                            object.node.data = {
                                id: this.tenantId + "-" + objectInfo.id,
                                tenantId: this.tenantId,
                                type: constants.OBJECT_TALKGROUP,
                                talkgroupId: objectInfo.id,
                                talkgroupName: objectInfo.name,
                                displayName: objectInfo.displayName,
                                label: objectInfo.name,
                            };
                            object.node.parent.data = {id: objectInfo.pid}
                            this.foundGroupList.push(object);
                        }
                        break;
                    default:
                        this.foundGroupList = [];
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "findGroup").replace("{code}", res.data.status));
                        break;
                }
            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "findGroup", e);
                this.foundGroupList = [];
            }
        },
        async handleOnSelectNode(data, node) {
            if (data.type !== constants.OBJECT_TALKGROUP) {
                return;
            }

            let key = data.tenantId + "-" + data.id;
            if (key in this.tagList) {
                return;
            }

            try {
                const res = await server.post('/getinfo', {tenantId: this.tenantId, id: data.id})
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        let tagInfo = {
                            id: key,
                            tenantId: this.tenantId,
                            type: constants.OBJECT_TALKGROUP,
                            talkgroupId: res.data.id,
                            talkgroupName: res.data.name,
                            displayName: res.data.displayName,
                            optionFlag: res.data.optionFlag,
                            label: res.data.name,
                        };
                        this.changeTag(tagInfo);
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "handleOnSelectNode").replace("{code}", res.data.status));
                        break;
                }
            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "handleOnSelectNode", e);
            }
        },
        addTag(tag) {
            Vue.set(this.tagList, tag.id , tag);
            this.disableSave = false;
        },
        // This logic is for single target group.
        changeTag(tag) {
            this.tagList = {};
            Vue.set(this.tagList, tag.id , tag);
            this.disableSave = false;
        },
        removeTag(tag) {
            Vue.delete(this.tagList, tag.id);
            this.disableSave = false;
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-select-dropdown__item {
    font-size: 12px;
}
.el-select-dropdown__item selected {
    color: #5171cb;
}
.dialog-tree >>> .el-tree-node__content {
    min-height: 40px !important;
    height: auto !important;
    white-space: normal !important;
    word-break: break-all !important;
    text-align: justify;
}
.dialog-tree >>>.el-tree-node__expand-icon {
    padding: 0px 28px !important;
}

</style>

